// extracted by mini-css-extract-plugin
export default {"title":"AccordionItem_title__ITx7l","wrapper":"AccordionItem_wrapper__xHm-e"};